module.exports = __webpack_public_path__ + "img/brand--mifarma.0568b6c5.png";